import { useCallback, useRef, useState } from "react"

import { logger } from "@/lib/logger"

const log = logger("useCopyToClipboard")
const COPY_FEEDBACK_MS = 2000

export function useCopyToClipboard(feedbackMs = COPY_FEEDBACK_MS) {
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const copy = useCallback(
    async (text: string) => {
      try {
        await navigator.clipboard.writeText(text)
        setCopied(true)
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current)
        }
        timeoutRef.current = setTimeout(() => setCopied(false), feedbackMs)
        return true
      } catch (err: unknown) {
        log.warn("Failed to copy to clipboard", { error: err })
        setCopied(false)
        return false
      }
    },
    [feedbackMs],
  )

  return { copied, copy } as const
}
